import { isNotEmpty, isNumber } from "../utils"

const formatter = new Intl.NumberFormat('en-US', {
	// style: 'currency',
	// currency: 'USD',
	minimumFractionDigits: 0,
	maximumFractionDigits: 0,
})

const setNumber = (str) => !isNotEmpty(str) ? '' : formatter.format(str.replace(/[^0-9]/g, ''))
const unsetNumber = (str) => !isNotEmpty(str) ? '' : Number(str.replace(/[^0-9]/g, ''))

class NumberFormat {
	el = null
	binding = null

	constructor() {
		this._onInput = this._onInput.bind(this)
		this._onKeydown = this._onKeydown.bind(this)
		this.isDeleting = false
	}

	_onKeydown(evt) {
		if (evt.key === 'Backspace' || evt.key === 'Delete') {
			this.isDeleting = true
		} else {
			this.isDeleting = false
		}
	}

	_onInput(evt) {
		const input = evt.target
		let newValue = setNumber(input.value)
		let rawValue = unsetNumber(input.value)


		if (input.value !== newValue) {
			input.setAttribute('data-raw', rawValue)
			input.removeEventListener('input', this._onInput, { capture: true })
			requestAnimationFrame(() => {
				if (input.value !== '') {
					input.value = newValue
				}
				input.dispatchEvent(new Event('input', { bubbles: true }))
				input.addEventListener('input', this._onInput, { capture: true })
			})
		} else if (input.value.length < 4) {
			input.setAttribute('data-raw', rawValue)
			input.removeEventListener('input', this._onInput, { capture: true })
			requestAnimationFrame(() => {
				input.value = newValue
				input.dispatchEvent(new Event('input', { bubbles: true }))
				input.addEventListener('input', this._onInput, { capture: true })
			})
		}

		this.isDeleting = false
	}

	mounted(el) {
		const input = el.querySelector('input')
		if (input) {
			let newValue = setNumber(input.value)
			let rawValue = unsetNumber(input.value)
			input.addEventListener('keydown', this._onKeydown)
			input.addEventListener('input', this._onInput, {capture: true} )

			if (input.value !== newValue) {
				requestAnimationFrame(() => {
					input.setAttribute('data-raw', rawValue)
					if (input.value !== '') {
						input.value = newValue
					}
					input.dispatchEvent(new Event('input', { bubbles: true }))
				})
			}

			el._onInputCleanup = () => {
				input.removeEventListener('keydown', this._onKeydown)
				input.removeEventListener('input', this._onInput, {capture: true} )
			}
		}
	}

	updated(el) {
		const input = el.querySelector('input')
		if (input && input.value != '') {
			let newValue = setNumber(input.value)
			let rawValue = unsetNumber(input.value)

			if (input.value != newValue) {
				input.value = newValue
				input.setAttribute('data-raw', rawValue)
			}
		}
	}

	unmounted(el) {
		if (el._onInputCleanup) {
			el._onInputCleanup()
			delete el._onInputCleanup
		}
	}
}

export const installNumberFormat = (app) => {
	const instance = new NumberFormat

	app.directive('numberFormat', {
		mounted: instance.mounted.bind(instance),
		unmounted: instance.unmounted.bind(instance),
		updated: instance.updated.bind(instance),
	})
}
